import { getAuthHeader } from '.';
import { ROOT_URL } from '../utils/constants';
import type { Contact } from '../models/Contact';

class ContactApi {
  static async getContactRoles() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/contactroles`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getContactsForUser(view: string): Promise<Contact[]> {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/contacts?view=${view}`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getContactById(id: number): Promise<Contact> {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/contacts/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async createContact(contact: Contact): Promise<Contact> {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/contacts`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify(contact),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async updateContact(contact: Contact): Promise<Contact> {
    const [headers] = await getAuthHeader();
    const response = await fetch(
      `${ROOT_URL}/api/contacts/${contact.contactId}`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(contact),
      },
    );
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async deleteContact(contactId: number) {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/contacts/${contactId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return true;
  }
}

export default ContactApi;
